import { render, staticRenderFns } from "./teamMember.vue?vue&type=template&id=ec765cbe&scoped=true&"
import script from "./teamMember.vue?vue&type=script&lang=js&"
export * from "./teamMember.vue?vue&type=script&lang=js&"
import style0 from "./teamMember.vue?vue&type=style&index=0&id=ec765cbe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec765cbe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ec765cbe')) {
      api.createRecord('ec765cbe', component.options)
    } else {
      api.reload('ec765cbe', component.options)
    }
    module.hot.accept("./teamMember.vue?vue&type=template&id=ec765cbe&scoped=true&", function () {
      api.rerender('ec765cbe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2QICPjRtoylWi/JS/teamMember.vue"
export default component.exports